import React from "react";
import ReactPlayer from "react-player";

import playIconSvg from "../../../images/svg/icons/icon-play-arrow.svg";


// Helper function to check if the URL is a format ReactPlayer supports.
const isUrlSupported = (urls) => {
	if (!urls || !urls.length) return false;

	const supportedUrl = urls.findIndex((url) => {
		const supportedPatterns =
			/(youtube\.com|youtu\.be|vimeo\.com|wistia\.com|wi\.st|mux\.com|\.mp4|\.webm|\.ogv|\.mp3|\.m3u8|\.mpd)/i;
		return supportedPatterns.test(url);
	})
	return supportedUrl;
};

const VideoPlayer = ({ videoUrls, posterUrl, config, caption }) => {
	const isSupportedIndex = isUrlSupported(videoUrls);

	if (isSupportedIndex === -1) {
		return (
			<div className="video-error">Sorry, this video URL is not supported.</div>
		);
	}

	return (
		<>
			<div className="video-player-wrapper">
				<ReactPlayer
					{...config}
					fallback={<img src={posterUrl} alt="Video poster" />}
					height="100%"
					width="100%"
					src={videoUrls[isSupportedIndex]}
					playIcon={<img src={playIconSvg} alt="play" className="play-icon" />}
					config={{
						youtube: {
							playerVars: {
								enablejsapi: 1,
							},
						},
					}}
				/>

			</div>
			{caption && <div className="video-caption" dangerouslySetInnerHTML={{__html: caption}}/>}
		</>
	);
};

export default VideoPlayer;
